module.exports = __webpack_public_path__ + "static/media/CGSE_Hero_England-MathSci.b08b5731.jpg";